
import s from "./testnet.module.css"
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ALL_PROJECTS, UPCOMING_PROJECTS, COMMUNITY, HYPE, SAVE_LIKES, VENTORY_PROJECTS, SORT_NUMBER } from "../../Redux/actions/actions";
import { Link, useNavigate } from "react-router-dom";
import { gradientBorder, gradientColor } from "../../helper/helper";
import InfoIcon from '@mui/icons-material/Info';
import * as React from 'react';
import { Waveform } from '@uiball/loaders'
import Navbar from "../Landing/navbar/navbar";
import ProjectInfo from "../Projects/ProjectInfo/ProjectInfo";
import VentoryProjectInfo from "./ventoryProject/VentoryProject";

<Waveform
    size={40}
    lineWeight={3.5}
    speed={1}
    color="black"
/>

export default function Testnet({ colorFondo }) {
    const dispatch = useDispatch()
    const topProjects = useSelector(state => state.clientReducer.ventoryProjects)
    let backgroundColor = gradientColor(colorFondo)
    let borderImage = gradientBorder(colorFondo)
    let dmText = "Attention,%20soldier!%20I%20hereby%20request%20the%20enlistment%20of%20my%20project!🫡🪖"

    // ---------------------
    const [sort, setSorted] = useState("floorChange")

    const sortNumber = (e) => {
        dispatch(SORT_NUMBER(e))
        setSorted(e)
    }
    const handleHype = () => {
        // dispatch(HYPE("minted"))
        // setSorted("hype")
    }
    //   ---------------


    useEffect(() => {
        dispatch(VENTORY_PROJECTS())
        // dispatch(UPCOMING_PROJECTS())
    }, [])
    return (
        <>
            <Navbar colorFondo={colorFondo} />
            <div className={s[colorFondo]}>
                <div className={s.tablaContainer}>
                    <div className={s.btnTitle}>
                        <div className={s.titleContainer}>
                            <h3 className={s.titulo}>Top VENOM nfts on TESTNET</h3>
                            <h4>Best <span> NFT</span> projects in the <span>Venom</span> ecosystem launched on <span> TESTNET.</span></h4>
                        </div>
                        <div className={s.buttonContainer}>
                            <div className={s.buttonDiv}><a style={backgroundColor} target="_blank" href={"https://twitter.com/messages/compose?recipient_id=1617597356001591325&text=" + dmText}
                                class="twitter-dm-button" data-screen-name="@furni">
                                List your Project</a>
                            </div>
                            <div className={s.buttonDiv}><Link to="/allProjects" style={backgroundColor}>All Projects</Link>
                            </div>
                        </div>
                    </div>
                    {topProjects?.length ?
                        <div className={s.grid}>
                            <div className={s.rows}>
                                <div><span></span></div>
                                <div><span></span></div>
                                <div><span>Project</span></div>
                                <div><span className={sort === "floorPrice" && s.underline} onClick={() => sortNumber("floorPrice")}>floor price</span></div>
                                <div><span className={sort === "floorChange" && s.underline} onClick={() => sortNumber("floorChange")}>floor Change</span></div>
                                <div className={s.hypeDiv}>
                                    <span className={sort === "volume" && s.underline} onClick={() => sortNumber("volume")}>volume</span>
                                </div>
                                <div><span className={sort === "volumeChange" && s.underline} onClick={() => sortNumber("volumeChange")}>Volume change</span></div>
                                <div><span className={sort === "owners" && s.underline} onClick={() => sortNumber("owners")}>owners</span></div>
                                <div><span className={sort === "items" && s.underline} onClick={() => sortNumber("items")}>items</span></div>
                            </div>
                            {
                                topProjects?.map((project, index) => {
                                    return (<VentoryProjectInfo i={index} project={project} />)
                                })
                            }
                        </div>
                        : <div style={{ paddingTop: '60px' }}>
                            <Waveform
                                size={40}
                                lineWeight={3.5}
                                speed={1}
                                color="black"
                            />
                        </div>}
                    {topProjects.length > 0 && <><Link to={"/allProjects"} style={borderImage} className={s.link}>Show More</Link></>
                    }

                </div>
            </div>
        </>
    )
}



